import $ from "jquery"

import Flash from "lib/flash"
import ErrorTrack from "lib/error_track"
import i18n from "lib/i18n"
import autocomplete from "lib/autocomplete"
import AcademicTitles from "lib/academic_titles"
import BasePage from "pages/base_page"
import { processImageFile } from "lib/images/uploads/image_handling"

const editProfilePageEvents = {
  "change input[type=file]": "handleAvatarChange",
  "click label#profile_form_sex_other_label": "focusOtherInput",
  "click input#profile_form_sex_other": "focusOtherInput",
  "input input#profile_form_sex_other_text": "chooseOther",
}

export default class EditProfilePage extends BasePage {
  get events() {
    return editProfilePageEvents
  }

  initialize(options) {
    super.initialize(options)
    this._crop = this._crop.bind(this)
    return this.autocompleteJobTitle()
  }

  async handleAvatarChange(event) {
    if (this._avatarBusy) return
    this._avatarBusy = true // we could use this for processing
    const input = event.currentTarget

    // Check if file exists
    if (!input.files || !input.files[0]) {
      this._avatarBusy = false
      return
    }

    try {
      const result = await processImageFile(input.files[0], {
        allowedTypes: ["image/jpeg", "image/png", "image/webp", "image/gif"],
        maxUploadSizeKB: 12 * 1024,
        sizeThresholdKB: 512,
        maxWidth: 1024,
        maxHeight: 1024,
        quality: 0.82,
      })

      switch (result.status) {
        case "success": {
          // Replace the original file with the processed file
          const dt = new DataTransfer()
          dt.items.add(result.file)
          input.files = dt.files

          this.showPhoto(event)
          break
        }
        case "invalid_type":
          this._clearFileSelection(input)
          Flash.now("alert", i18n.t("editorial.avatar.invalid_type"))
          break
        case "file_too_large":
          this._clearFileSelection(input)
          Flash.now(
            "alert",
            i18n.t("editorial.avatar.file_too_large", {
              maxSizeMB: Math.floor(result.maxSizeKB / 1024),
            }),
          )
          break
        case "resize_failed":
          this._clearFileSelection(input)
          Flash.now("alert", i18n.t("editorial.avatar.resize_failed"))
          break
        case "empty":
          // no file selected, do nothing
          break
      }
    } catch (e) {
      ErrorTrack.notify(e, {
        context: "avatar_upload_error",
        fileName: input.files?.[0]?.name || "unknown",
        fileSize: input.files?.[0]?.size || "unknown",
        fileType: input.files?.[0]?.type || "unknown",
      })
      this._clearFileSelection(input)
      Flash.now("alert", i18n.t("editorial.avatar.processing_error"))
    } finally {
      this._avatarBusy = false
    }
  }

  showPhoto(event) {
    const originalImage = $("#avatar-wrapper > img") // this should probably be passed in from elsewhere
    const input = $(event.currentTarget).get(0)

    if (this._fileReaderExists() && this._inputHasFiles(input)) {
      const reader = new FileReader()
      reader.onload = (event) => {
        // Create a temporary image object
        const img = new Image()
        img.onload = (event) => this._crop(originalImage, event.currentTarget)

        // Set the source of the temporary image to the base64 data of selected image, this fires onload
        return (img.src = event.target.result)
      }

      return reader.readAsDataURL(input.files[0])
    }
  }

  chooseOther() {
    $("#profile_form_sex_other").prop("checked", true)
  }

  focusOtherInput() {
    $("#profile_form_sex_other_text").focus()
  }

  autocompleteJobTitle() {
    $(".occupation.autocomplete").each(function () {
      return autocomplete($(this), {
        source: AcademicTitles.list,
        minLength: 2,
        autoFocus: true,
        delay: 200,
        select(event, ui) {
          return this.val(ui.item)
        },
      })
    })
  }

  _fileReaderExists() {
    return typeof FileReader !== "undefined"
  }

  _inputHasFiles(input) {
    return input.files && input.files[0]
  }

  _getCroppedImageElementFor(originalImage) {
    const container = originalImage.parent()
    const croppedImage = container.find(".replacedAvatar")
    // If there already is a replacement Image div, use that, else append one to the container
    if (croppedImage.length > 0) {
      return croppedImage
    }
    container.append("<div class='replacedAvatar'></div>")
    return container.find(".replacedAvatar")
  }

  _crop(originalImage, newImage) {
    const croppedImage = this._getCroppedImageElementFor(originalImage)
    croppedImage.hide()
    croppedImage.css("background", `url(${newImage.src}) no-repeat center center`)

    // Set the cropping similar to what would happen server-side
    croppedImage.css("background-size", "cover")
    croppedImage.width(originalImage.width())
    croppedImage.height(originalImage.height())
    originalImage.hide()
    return croppedImage.fadeIn()
  }
  _clearFileSelection(input) {
    try {
      const dt = new DataTransfer()
      input.files = dt.files
    } catch {
      input.value = ""
    }
    const t = input.type
    input.type = ""
    input.type = t
  }
}
